import { render } from "./ArticleModal.vue?vue&type=template&id=769b74a0&scoped=true"
import script from "./ArticleModal.vue?vue&type=script&lang=js"
export * from "./ArticleModal.vue?vue&type=script&lang=js"

import "./ArticleModal.vue?vue&type=style&index=0&id=769b74a0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-769b74a0"

export default script